import VideoEnvironment from "../Components/Environments/React/VideoEnvironment";
import BaseScenario from "./BaseScenario";
import { Segments } from "./Segments";

/**
 * Base class for all parts in a scenario
 */
export default class BaseScenarioPart<ScenarioType extends BaseScenario> {

	constructor (public scenario: ScenarioType) {
		
	}
	/**
	 * The id of the part
	 */
	public get partId(): string {
		throw new Error('partId must be implemented');
	}

	public get videoUrl(): string[] {
		throw new Error('videoUrl must be implemented');
	}

	/**
	 */
	 public start(): void {
		throw new Error('start must be implemented');
	}

	public playVideoChapter(chapterId: string, onDone: () => void, loop?: boolean): void {
		(this.scenario.gameManager.environment as VideoEnvironment).playSequence({
			sequenceName: 'video',
			props: {
				partId: this.partId,
				chapterId: chapterId,
				loop: loop
			},
			onDone: onDone
		})
	}
}